import STATUSES from './../config/trip.constant';
import trainTravelModes from '../../train/train-travel-modes';
export const DEFAULT_TRAVEL_MODE_CLASS = 'i-eurostar-small';

export default function TripItemService(
    tripDetailsService
) {
    'ngInject';

    Object.assign(this, {
        itemCannotBeCancelled,
        itemCannotBeAmended,
        getRailIconClass,
		isTripItemCancelled,
    });

    function itemCannotBeCancelled(tripItem, tripDetails) {
        return !tripItem.CanBeCancelled || tripDetails.IsOfflineTrip
            || isTripItemCancelled(tripItem, tripDetails);
    }

    function itemCannotBeAmended(tripItem, tripDetails) {
        return tripDetails.IsOfflineTrip
            || isTripItemCancelled(tripItem, tripDetails)
            || tripItem.Status !== STATUSES.TRIP_STATUSES.CONFIRMED;
    }

    function isTripItemCancelled(tripItem, tripDetails) {
        return tripDetails.Locked
            || tripItem.Status === STATUSES.TRIP_STATUSES.CANCELLED
            || tripDetailsService.isTripCancelled(tripDetails);
    }

    function getRailIconClass(rail) {
        const iconClasses = {
            [trainTravelModes.TRAIN]: 'i-eurostar-small',
            [trainTravelModes.TUBE]: 'i-tube-small',
            [trainTravelModes.BUS]: 'i-car-small',
            [trainTravelModes.TAXI]: 'i-car-small',
            [trainTravelModes.METRO]: 'i-tube-small',
            [trainTravelModes.TRANSFER]: 'i-car-small',
        };

        return iconClasses[rail.TravelMode]
            || DEFAULT_TRAVEL_MODE_CLASS;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-group/trip-item-service.js